const actions = {
  setProgress({ commit }, progress) {
    commit('SET_PROGRESS', progress)
  },
  resetProgress({ commit }, type) {
    commit('RESET_PROGRESS', type)
  },
}

export { actions }
